import React, { useState } from 'react'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button, Input } from '@arnsbogroup/react-voicearchive'
import DateTime from 'react-datetime'

const ReportHeader = ({
    loading = false,
    onSearch = () => {},
}) => {
    const { formatMessage } = useIntl()
    const [searchParams, setSearchParams] = useState({
        orderNumber: null,
        customerNumber: null,
        dateFrom: null,
        dateTo: null
    })

    return (
        <div className='flex gap-2 p-2'>
            <div className='w-1/3 my-auto'>
                <Input
                    disabled={loading}
                    key='orderNumber'
                    defaultValue={searchParams.orderNumber}
                    type="number"
                    onBlur={({ target: { value } }) => setSearchParams((prev) => ({ ...prev, orderNumber: value }))}
                    placeholder={formatMessage(messages.orderNumberPlaceholder)}
                    className="border-gray-200"
                    floatingLabel={formatMessage(messages.orderNumber)}
                    onKeyDown={({ key, target: { value } }) => {
                        if (key == 'Enter') {
                            setSearchParams((prev) => ({ ...prev, orderNumber: value }))
                        }
                    }}
                />
            </div>
            <div className='w-1/3 my-auto'>
                <Input
                    disabled={loading}
                    key='customerNumber'
                    defaultValue={searchParams.customerNumber}
                    type="number"
                    onBlur={({ target: { value } }) => setSearchParams((prev) => ({ ...prev, customerNumber: value }))}
                    placeholder={formatMessage(messages.customerNumberPlaceholder)}
                    className="border-gray-200"
                    floatingLabel={formatMessage(messages.customerNumber)}
                    onKeyDown={({ key, target: { value } }) => {
                        if (key == 'Enter') {
                            setSearchParams((prev) => ({ ...prev, customerNumber: value }))
                        }
                    }}
                />
            </div>
            <div className='w-1/3 my-auto'>
                <DateTime
                    disabled={loading}
                    key='dateFrom'
                    onChange={(value) => setSearchParams((prev) => ({ ...prev, dateFrom: Math.round(new Date(value).getTime() / 1000) }))}
                    closeOnSelect
                    className="p-4 border border-gray-200 focus:border-primary"
                    inputProps={{
                        placeholder: formatMessage(messages.dateFrom),
                        className: "border-none"
                    }}
                />
            </div>
            <div className='w-1/3 my-auto'>
                <DateTime
                    disabled={loading}
                    key='dateTo'
                    onChange={(value) => setSearchParams((prev) => ({ ...prev, dateTo: Math.round(new Date(value).getTime() / 1000) }))}
                    closeOnSelect
                    className="p-4 border border-gray-200 focus:border-primary"
                    inputProps={{
                        placeholder: formatMessage(messages.dateTo),
                        className: "border-none"
                    }}
                />
            </div>

            <div className="flex gap-2">
                <div className='my-auto'>
                    <Button
                        onClick={() => onSearch(searchParams)}
                        size="base"
                        disabled={loading}
                    >
                        <FormattedMessage {...messages.search} />
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default ReportHeader
